module.exports = __webpack_public_path__ + "static/media/musiksektionen.888acf67.png";